<template>
  <div class="nav-compoment">
    <a href="https://beian.miit.gov.cn/">{{ hao }}</a>
  </div>
</template>

<script>
const height = document.body.clientHeight
import { pathMatcher } from '@/utils/index'
export default {
  data() {
    return {
      hao: '赣ICP备2024051680号-1',
      list: ['user/order/preAllList', 'user/order/list/', 'yesterday/', 'fansOrder', 'fans', 'income', 'user/order/warehouseList', 'user/order/preList']
    }
  },
  created() {

  },
  updated() {
    const route = this.$route.fullPath
    console.log('当前页路由', route)
    console.log('当前页路由是否在LIST中', pathMatcher(this.list, route))
  },
  methods: {
  }
}
</script>

  <style lang="scss" scoped>

  .nav-compoment{
    background-color: #f9f9f9;
    width: 100%;
    line-height: 20px;
    margin-bottom: 50px;
    // position: absolute;
    font-size: 20px;
    // bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    // position: relative;
    color: #e6e6e660;

    a{
        position: absolute;
        bottom: 120px;
    }
  }
  </style>
